import React from "react";
import styled from "@emotion/styled";
import { Button, Form, message, Tabs } from "antd";

import { PlusCircleOutlined } from "@ant-design/icons";
import useDealManagerData from "./hooks/useDealManagerData";
import useScreenSizeHook from "../../utils/useScreenSizeHook";
import { CustomTable } from "../../series/StyledComponent";
import ChannelModal from "./modals/Channel";
import PlatformModal from "./modals/Platform";
import PartnerModal from "./modals/Partner";
import TerritoyModal from "./modals/Territory";
import { CustomModal } from "../../utils/StyledComponents";
import { DealManagerView } from "./hooks/utils";
import { FormInstance } from "antd/lib";
import DealGridForm from "./modals/DealGridFrom";
import DealsForm from "./modals/Deals";

export interface DealManagerComponentProps {
  height: number;
  data: any[];
  isLoading: boolean;
  columns: any[];
  pagination: any;
  handleTableChange: (pagination: any, filters: any, sorter: any) => void;
}


// form, isLoading, editId, saveEditHandler, isModalOpen, closeModalHandler
export interface DealManagerComponentModalProps {
  editId?: number;
  form: FormInstance;
}

const TabsWrapper = styled.div`
  // margin-bottom: 16px;
  & .ant-tabs-tab-btn {
    color: #ccc;
  }

  & .ant-tabs-nav {
    margin-bottom: 0;

    ::before {
      border-bottom: none;
    }
  }

`;

const tabItems: {key: DealManagerView; label: string}[] = [
  { key: "deals", label: "Deals" },
  { key: "deal-grid", label: "Deal Grid" },
  { key: "platform", label: "Platform" },
  { key: "partner", label: "Partner" },
  { key: "channel", label: "Channel" },
  { key: "territory", label: "Territory" },
];

const subComponentText: {[key: string]: string} = {
  "deals": "Deals",
  "deal-grid": "Deal Grid",
  platform: "Platform",
  partner: "Partner",
  channel: "Channel",
  territory: "Territory",
}

const DealManager: React.FC = () => {
  const { height } = useScreenSizeHook();
  
  const { isFormLoading, setIsFormLoading, wholeData, view, setView, form, data, openEditForm, isLoading, columns, pagination, isModalOpen, handleTableChange, setIsModalOpen, editId, closeModalHandler, saveEditHandler } = useDealManagerData();

  const onChangeHandler = (key: DealManagerView) => {
    setView(key);
  }

  return (
    <TabsWrapper>
      <Tabs
        items={tabItems}
        tabBarExtraContent={<Button type="primary" icon={<PlusCircleOutlined />} onClick={() => setIsModalOpen(true)}>Add {subComponentText[view]}</Button>}
        activeKey={view}
        onChange={(key) => onChangeHandler(key as DealManagerView)}
      />
      <CustomTable
        // bordered
        columns={columns as any}
        dataSource={data}
        loading={isLoading}
        pagination={pagination}
        scroll={{ x: 700, y: height - 265 }}
        onChange={handleTableChange as any}
        onRow={(record: any) => {
					return {
						onClick: () => {
							openEditForm(record);
						},
					};
				}}
      />
      <CustomModal
        centered
        title={subComponentText[view]}
        open={isModalOpen}
        onCancel={closeModalHandler}
        onOk={() => {
          console.log("onOk clicked");
          saveEditHandler();
        }}
				okText={editId ? "Update" : "Add"}
				okButtonProps={{ type: "primary", disabled: isFormLoading }}
				cancelButtonProps={{ disabled: isFormLoading }}
      >
        <Form form={form} requiredMark={false} layout="vertical" onFinish={saveEditHandler} >
          {view === "deal-grid" && 
            <DealGridForm form={form} wholeData={wholeData} />
          } 
          {view === "platform" && <PlatformModal form={form} editId={editId} />}
          {view === "deals" && <DealsForm form={form} wholeData={wholeData} />}
          {view === "partner" && <PartnerModal form={form} editId={editId} />}
          {view === "channel" && <ChannelModal form={form} editId={editId} />}
          {view === "territory" && <TerritoyModal form={form} editId={editId} />}
        </Form>
      </CustomModal>
    </TabsWrapper>
  );
};

export default DealManager;